import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  change(event) {
    const newProofType = event.target.value

    // Show saving indicator
    event.target.style.opacity = '0.5'

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        school: {
          proof_type: newProofType
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      event.target.style.opacity = '1'
      if (data.success) {
        // Flash green briefly to indicate success
        event.target.style.backgroundColor = '#d4edda'
        setTimeout(() => {
          event.target.style.backgroundColor = ''
        }, 1000)
      } else {
        alert('Failed to save proof type')
      }
    })
    .catch(error => {
      event.target.style.opacity = '1'
      console.error('Error:', error)
      alert('Failed to save proof type')
    })
  }
}
